import React from "react";
import { Link } from "react-router-dom";
import PageHelmet from "../component/common/Helmet";
import HeaderAbs from "../component/header/HeaderAbs";
import FooterTwo from "../component/footer/FooterTwo";
import BlogContent2 from "./blog/BlogContent2";

const ReferenceArchitectures = () => {
    return (
        <React.Fragment>
            <PageHelmet
                pageTitle="Reference Architectures"
                description="Deep-dive reference architectures for enterprise AI: RAG, agent orchestration, evaluation, observability, and governance."
                canonical="https://www.theomefford.com/reference-architectures"
            />

            <HeaderAbs homeLink="/" logo="symbol-dark" color="color-black" />

            <div className="rn-page-title-area pt--120 pb--70 bg_color--1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="blog-single-page-title text-center pt--60">
                                <h2 className="title theme-gradient">Reference Architectures</h2>
                                <p className="description">
                                    Technical deep dives designed for builders: architectures, key decisions, failure modes, and evaluation strategy.
                                </p>
                                <p className="mt--20">
                                    <Link to="/recent-work">← Recent Work</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="rn-blog-area pt--80 pb--120 bg_color--5">
                <div className="container">
                    <div className="row mt--10">
                        {BlogContent2.map((value, i) => (
                            <div className="col-lg-4 col-md-6 col-12" key={i}>
                                <div className="blog blog-style--1">
                                    <div className="thumbnail">
                                        <Link to={value.ref}>
                                            <img className="w-100" src={value.image} alt={value.title} />
                                        </Link>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">
                                            <Link to={value.ref}>{value.title}</Link>
                                        </h4>
                                        <div className="blog-text">
                                            <p>{value.description}</p>
                                        </div>
                                        <div className="blog-btn">
                                            <Link className="rn-btn text-white" to={value.ref}>
                                                Read More
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <FooterTwo />
        </React.Fragment>
    );
};

export default ReferenceArchitectures;
